import { CampoDeSelecaoMultipla } from '../componentes/ui';
import { VINCULOS_TRABALHISTAS } from './vinculos-trabalhistas';

/**
 * Vínculo trabalhista — o campo de seleção múltipla com chips do Deca 1
 * (`EmpresaEmployers.js`, Autocomplete multiple), com a mesma lista.
 *
 * Já foi um grupo de caixas; a operação pediu o modelo antigo (lista de
 * 15/09, item 13). Usado no cadastro pelo gestor e no formulário público: é a
 * mesma pergunta, com a mesma lista.
 */
export function SeletorDeVinculos(props: {
  readonly escolhidos: readonly string[];
  readonly aoMudar: (v: string[]) => void;
  readonly ajuda?: string;
}): JSX.Element {
  return (
    <CampoDeSelecaoMultipla
      rotulo="Vínculo trabalhista"
      placeholder="Vínculo trabalhista"
      opcoes={VINCULOS_TRABALHISTAS}
      escolhidos={props.escolhidos}
      aoMudar={props.aoMudar}
      ajuda={
        props.ajuda ??
        'Pode marcar mais de um. "Decisor" recebe o pedido de aprovação do crédito; "Contábil" e "Financeiro" recebem as cobranças do cronograma.'
      }
    />
  );
}
